import { render, staticRenderFns } from "./007_NSC.vue?vue&type=template&id=2317d19c&scoped=true&"
import script from "./007_NSC.vue?vue&type=script&lang=js&"
export * from "./007_NSC.vue?vue&type=script&lang=js&"
import style0 from "./007_NSC.vue?vue&type=style&index=0&id=2317d19c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2317d19c",
  null
  
)

export default component.exports